<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        center-active
        show-arrows
        >
            <v-tab>Chemical Details</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="chemicalform">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Name" rules="required">
                                                <v-text-field
                                                v-model="form.name"
                                                :error-messages="errors"
                                                label="Chemical Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Unit Price" rules="required">
                                                <v-text-field
                                                v-model="form.unit_price"
                                                :error-messages="errors"
                                                label="Unit Price"
                                                prefix="$"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Measurment Type" rules="required">
                                                <v-select
                                                    v-model="form.measurement_type"
                                                    :items="measurement_types"
                                                    :error-messages="errors"
                                                    label="Measurment Type"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>   
                        <v-btn large min-width="50%" color="blue darken-1" text to="/dashboard">Cancel</v-btn>                     
                        <v-btn large min-width="50%" color="primary" tile @click="submit" :loading="loading">Save</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    props: ['id'],
    data () {
        return {
            tab: null,
            form: {
                name: '',
                unit_price: '',
                measurement_type: '',

            },
            loading: false,
        }
    },
    created() {
        if(this.id != 0) {
            this.getChemical()
        }
    },
    computed: {
        ...mapGetters({
            measurement_types: 'data/measurement_types'
        }),
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        getChemical() {
            if(this.id) {
                axios.get('admin/chemicals/get?id=' + this.id)
                    .then((response) => {
                        this.form.name = response.data.title
                        this.form.unit_price = response.data.unit_price
                        this.form.measurement_type = response.data.measurement_type
                        this.$nextTick()
                    })
            }
        },
        ...mapActions({
            addChemical: 'data/addChemical',
            updateChemical: 'data/updateChemical'
        }),
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.$set(this.form, 'id', this.id)

                if(this.id != 0) {
                    this.updateChemical(this.form).then(() => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                        this.$router.push({ path: '/chemicals' })
                    }).catch(error => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        if(error.response.data.error) {
                            this.$store.commit('SET_SNACK', error.response.data.error)
                        } else {
                            this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                        }
                    })
                } else {
                    this.addChemical(this.form).then(() => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                        this.$router.push({ path: '/chemicals' })
                    }).catch(error => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        if(error.response.data.error) {
                            this.$store.commit('SET_SNACK', error.response.data.error)
                        } else {
                            this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                        }
                    }) 
                }
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
    }
}
</script>